export default __webpack_public_path__ + "media/gallery/audi-ae36f9f2.jpg";